import { IAdvertiserGridRow } from '@/Interfaces/Advertiser.interface';
import ExportIcon from '@/components/Icons/ExportIcon';
import ArchiveButton from '@/pages/Advertisers/AdvertisersGrid/components/ArchiveButton';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectIsAdmin } from '@/store/selectors/me.selectors';
import { setSelectedAdvertiser } from '@/store/slices/advertisers.slice';
import { Button, styled } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { useCallback } from 'react';

const ViewAdvertiserBtn = styled(Button)(({ theme }) => ({
  minHeight: '29px',
  paddingTop: 0,
  paddingBottom: 0,
  borderRadius: theme.shape.borderRadius * 4,
  textWrap: 'nowrap',
  maxWidth: '200px',
  '& .MuiButton-startIcon': {
    marginRight: theme.spacing(1),
  },
  '& .MuiButton-label': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

const ActionsCell = ({ row }: GridRenderCellParams<IAdvertiserGridRow>) => {
  const dispatch = useAppDispatch();

  const isAdmin = useAppSelector(selectIsAdmin);

  const selectRow = useCallback(() => {
    if (!row) return;
    dispatch(setSelectedAdvertiser(row));
  }, [dispatch, row]);

  return (
    <div className='flex justify-center'>
      <ViewAdvertiserBtn
        startIcon={<ExportIcon className='w-[11px]' />}
        variant='outlined'
        color='primary'
        onClick={selectRow}
        aria-label={`View details for ${row?.name || 'advertiser'}`}
      >
        View
      </ViewAdvertiserBtn>
      {isAdmin && <ArchiveButton row={row} />}
    </div>
  );
};

export default ActionsCell;
